import { render, staticRenderFns } from "./AlgorithmPanel.vue?vue&type=template&id=3444247e&scoped=true"
import script from "./AlgorithmPanel.vue?vue&type=script&lang=js"
export * from "./AlgorithmPanel.vue?vue&type=script&lang=js"
import style0 from "./AlgorithmPanel.vue?vue&type=style&index=0&id=3444247e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3444247e",
  null
  
)

export default component.exports